import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import BankAccountForm from '../../../BankAccountForm'

import useMutationUpdateBankAccount from '@/modules/bank/api/hooks/useMutationUpdateBankAccount'
import useQueryGetBankAccountById from '@/modules/bank/api/hooks/useQueryGetBankAccountById'
import Spinner from '@/common/components/Spinner'
import { BankAccountType, ValidateMethod } from '@/schema'
import { FormValues } from '../../../BankAccountForm/BankAccountFormSchema'
import { BankQueryKeys } from '@/modules/bank/keys'
import { useQueryClient } from '@tanstack/react-query'

export default function EditBankAccountForm() {
	const navigate = useNavigate()
	const { id } = useParams()
	const { mutate: updateBankAccount } = useMutationUpdateBankAccount()
	const { data: bankAccount, isLoading } = useQueryGetBankAccountById(id!)
	const queryClient = useQueryClient()

	const onSubmit = (values: FormValues) => {
		updateBankAccount(
			{
				id: id!,
				payload: {
					...values,
					validateType: values.validateType as ValidateMethod[],
					bankType: values.bankType as BankAccountType,
					appCredential: values.appCredential
						? {
								deviceId: values.appCredential.deviceId!,
								pin: values.appCredential.pin!,
							}
						: undefined,
					bankApiCredential: values.bankApiCredential
						? {
								username: values.bankApiCredential.username!,
								password: values.bankApiCredential.password!,
							}
						: undefined,
				},
			},
			{
				onSuccess: () => {
					toast.success('แก้ไขบัญชีธนาคารสำเร็จ')
					navigate('/operator/bank-account')
					queryClient.invalidateQueries({
						queryKey: [BankQueryKeys.BankAccountById, id],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	if (!bankAccount || isLoading) return <Spinner />

	return (
		<BankAccountForm
			mode="edit"
			onSubmit={onSubmit}
			defaultValues={{
				accountName: bankAccount.accountName,
				accountNumber: bankAccount.accountNumber,
				bankProvider: bankAccount.bankProvider,
				bankType: bankAccount.bankAccountType,
				isActive: bankAccount.isActive,
				validateType: bankAccount.validateMethods as unknown as (
					| 'SMS'
					| 'BANK_API'
					| 'BANK_APP'
				)[],
			}}
		/>
	)
}
